import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../data/content";

export const CtaBanner = ({ title = "Ihr Grundstück soll wieder gepflegt aussehen?" }) => (
    <section className="px-4 sm:px-6 lg:px-12 pb-20 lg:pb-28 pt-4 max-w-7xl mx-auto">
        <Reveal>
            <div className="relative bg-forest-deep grain rounded-3xl px-8 py-14 sm:px-14 sm:py-16 text-center overflow-hidden" data-testid="cta-banner">
                <h2 className="font-display font-semibold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl leading-tight max-w-2xl mx-auto">
                    {title}
                </h2>
                <p className="mt-4 text-base sm:text-lg text-white/65 max-w-xl mx-auto leading-relaxed">
                    Kurze Anfrage, kostenlose Besichtigung oder Foto-Einschätzung, verbindliches Festpreis-Angebot.
                    Kostenlos und unverbindlich.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row gap-3.5 justify-center">
                    <Link
                        to="/angebot"
                        data-testid="cta-banner-quote"
                        className="inline-flex items-center justify-center gap-2.5 bg-white text-forest-deep font-semibold px-7 py-4 rounded-full text-base transition-[transform,box-shadow] duration-200 hover:scale-[1.03] hover:shadow-[0_8px_40px_rgba(255,255,255,0.25)]"
                    >
                        Jetzt Anfrage senden
                        <ArrowRight size={17} strokeWidth={2.4} />
                    </Link>
                    <a
                        href={CONTACT.phoneHref}
                        data-testid="cta-banner-call"
                        className="inline-flex items-center justify-center gap-2.5 border border-white/35 text-white font-semibold px-7 py-4 rounded-full text-base transition-colors duration-200 hover:bg-white/10 hover:border-white/60"
                    >
                        <Phone size={16} strokeWidth={2.4} />
                        {CONTACT.phoneDisplay}
                    </a>
                </div>
            </div>
        </Reveal>
    </section>
);
